// extracted by mini-css-extract-plugin
export default {"Notification":"Notification_PAXFv","Notification___isHidden":"Notification___isHidden_OqWYW"};